// Filters uit de URL valideren vóór ze naar de API gaan (POST /jobs/search, GET /jobs).
// Bots/scanners en kapotte links (bv. jobDomains=jobdomain-services?jobDomains=..., XSS-payloads, page=99999)
// gaven anders een 422 van de API -> Sentry (SYNERGIEFRONTENDS-1DW, 2AB, 1DM en APISYNERGIEJOBSBE-NCH).
// Zelfde formaat als de API-validatie (vaste prefix + slug). jobDomains bewust niet tegen shared/utils/jobdomains:
// die lijst bevat niet alle domeinen die de API kent.
// De geldige waarden komen uit vaste lijsten in intranetapi (src/json/jobDomains.json, contractTypes.json,
// laborRegimes.json, jobExperiences.json); de Carerix-sync mapt daarop. Nieuwe waarden daar dezelfde naamgeving geven,
// anders vallen ze hier stil weg als filter.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const facetPatterns = {
  jobDomains: /^jobdomain-[a-z-]+$/,
  contractTypes: /^contract-type-[a-z0-9-]+$/,
  laborRegimes: /^labor-regime-[a-z0-9-]+$/,
  experiences: /^experience-[a-z0-9-]+$/,
};

export const filterValidFacetValues = (facet: keyof typeof facetPatterns, values: string[]): string[] =>
  values.filter((value) => facetPatterns[facet].test(value));

// Paginanummer uit de URL; ongeldig -> undefined (API valt terug op pagina 1).
// Max 1001: de API laat voor /jobs/search maximaal fromHits 10000 toe (10 resultaten per pagina).
export const toValidPage = (page: unknown): number | undefined => {
  const pageNumber = Number(page);
  return Number.isInteger(pageNumber) && pageNumber >= 1 && pageNumber <= 1001 ? pageNumber : undefined;
};
